module.exports = require("./fr-CA.js");